import React, { Component } from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN_850,
  MEDIA_QUERY_LARGE_SCREEN_1400,
  MEDIA_QUERY_LARGE_SCREEN_1080,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_BLUE,
  SR_BUTTON_HEIGHT_TALL,
} from 'client/components/SrButton/SrButton';

import {
  SCREEN_ID_PARTNER_MARKETING_MAKE_LEASING_SIMPLE,
} from 'client/constants/screenIds';

import withScreenId from 'client/helpers/withScreenId';

const MakeLeasingSimpleDOM = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  const isDesktopScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1400,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1080,
  });

  return (
    <SrBox paddingBottom='100px'>
      <SrFlex
        maxWidth='1400px'
        margin='0 auto'
        padding={isSmallScreen ? '10px 40px 20px 40px' : '30px 40px 20px 40px'}
        justify={isDesktopScreen ? 'center' : null}
        boxSizing='border-box'
      >
        <SrLink to='/feed'>
          <img
            alt='logo'
            src='/images/sunroom-logo-yellow.svg'
            width='200px'
            height='50px'
          />
        </SrLink>
      </SrFlex>
      <SrFlex
        maxWidth='1400px'
        margin='0 auto'
        wrap='wrap'
        height='calc(100% - 204px)'
        minHeight={isDesktopScreen ? 'auto' : 'calc(100vh - 204px)'}
        width='100%'
        padding={isLargeScreen ? '0 22px' : '0 0 0 40px'}
        boxSizing='border-box'
        align='center'
      >
        <SrFlex
          align='center'
          height='calc(100% - 204px)'
          width={isDesktopScreen ? '100%' : null}
        >
          <SrBox
            maxWidth={isDesktopScreen ? '100%' : '620px'}
            boxSizing='border-box'
            marginRight={isDesktopScreen ? null : '80px'}
            marginTop={isDesktopScreen && !isSmallScreen
              ? '30px'
              : null
            }
            width={isDesktopScreen ? '100%' : null}
          >
            <SrBox
              marginBottom={isLargeScreen ? null : '24px'}
            >
              <SrText
                font='greycliff'
                weight='800'
                size={isLargeScreen ? '40' : '64'}
                lineHeight={isLargeScreen ? '48px' : '77px'}
                color='black'
                align={isDesktopScreen && !isSmallScreen
                  ? 'center'
                  : null
                }
                display='block'
              >
                Make Leasing Simple
              </SrText>
            </SrBox>
            <SrBox maxWidth={isDesktopScreen ? null : '460px'} marginTop={isLargeScreen ? '16px' : '39px'}>
              <SrText
                font='greycliff'
                weight='600'
                size={isLargeScreen ? '16' : '24'}
                lineHeight={isLargeScreen ? '32px' : '39px'}
                color='greyDark'
                opacity='0.8'
                align={isDesktopScreen && !isSmallScreen
                  ? 'center'
                  : null
                }
                display='block'
              >
                Sunroom helps busy realtors lease homes &amp; impress their clients.
              </SrText>
            </SrBox>
            <SrFlex
              marginTop={isSmallScreen ? '47px' : '72px'}
              align='center'
              marginBottom='81px'
              width={isDesktopScreen ? '100%' : null}
              justify={isDesktopScreen ? 'center' : null}
              wrap='wrap'
            >
              <SrLink
                to='/signup-agent'
                target='_blank'
                style={{ width: isSmallScreen ? '100%' : null }}
              >
                <SrButton
                  theme={SR_BUTTON_THEME_ADOBE_BLUE}
                  heightType={SR_BUTTON_HEIGHT_TALL}
                  minWidth={isSmallScreen ? '100%' : '190px'}
                >
                  Get Started
                </SrButton>
              </SrLink>
              <SrBox
                width={isSmallScreen ? '100%' : '33px'}
                marginBottom={isSmallScreen ? '21px' : null}
              />
              <SrLink to='https://sunroomleasing.com/pages/how-it-works' target='_blank'>
                <SrText
                  color='blue300'
                  weight='800'
                  size='21'
                  font='greycliff'
                >
                  Learn More
                </SrText>
              </SrLink>
            </SrFlex>
          </SrBox>
        </SrFlex>
        <SrBox
          order={isDesktopScreen ? -1 : null}
          width={isDesktopScreen ? '100%' : null}
          marginLeft={isDesktopScreen ? '8px' : null}
          marginTop={isDesktopScreen && !isSmallScreen
            ? '40px'
            : null
          }
        >
          <SrFlex
            height={isDesktopScreen
              ? 'auto'
              : 'calc(100vh - 250px)'
            }
            align='center'
            justify={isDesktopScreen ? 'center' : null}
            width={isDesktopScreen ? '100%' : null}
          >
            <img
              alt='app preview'
              src='/images/devices-mockup.jpg'
              style={{
                maxWidth: isMediumScreen ? '80%' : 'calc(100vw - 700px)',
                width: isMediumScreen
                  ? '80%'
                  : isDesktopScreen
                    ? '40vw'
                    : '640px',
                flexShrink: 0,
              }}
            />
          </SrFlex>
        </SrBox>
      </SrFlex>
    </SrBox>
  );
};

@withScreenId(SCREEN_ID_PARTNER_MARKETING_MAKE_LEASING_SIMPLE)
class PartnerMakeLeasingSimplePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Make Leasing Simple | Sunroom Rentals',
  })

  render() {
    return <MakeLeasingSimpleDOM />;
  }
}

PartnerMakeLeasingSimplePage.displayName = 'PartnerMakeLeasingSimplePage';

export default PartnerMakeLeasingSimplePage;
